<template lang="pug">
  #login
    b-container.pa-0(fluid)
      b-row.full-layout.justify-content-md-center
        b-col.center-card(cols="12" md="5")
          b-card.pa-5(flat class="mb-5")
            .row.d-flex.align-items-center.justify-content-center
              b-col.py-4(cols="12" md="10")
                .title.px-1.px-md-5
                  img(src="assets/elquemado.jpg")
                  //- h1.px-3.title
                  //-   span.theme-text Memorial
                  //-   br
                  //-   | El Quemado&nbsp;
                b-form.px-1.px-md-5
                  b-form-input.mg-input(
                    placeholder="E-mail"
                    type="email"
                    :state="emailRules"
                    v-model="email"
                    box
                    hint=""
                    persistent-hint
                  )
                  b-form-input(
                    placeholder="Contraseña"
                    type="password"
                    :state="passwordRules"
                    v-model="password"
                    :append-icon="e1 ? 'visibility' : 'visibility_off'"
                    :append-icon-cb="() => (e1 = !e1)"
                    :type="e1 ? 'password' : 'text'"
                    name="password"
                    box
                    hint=""
                    persistent-hint
                    min="8"
                    counter
                  )
                  b-button.purple-btn.bold.mt-5(@click="login") Entrar
</template>

<script>
export default {
  name: "Login",
  props: {},
  data() {
    return {
      email: "",
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      e1: true,
      password: ""
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    emailRules() {
      return (this.email == "") ? false : (this.reg.test(this.email)) ? true : false;
    },
    passwordRules() {
      return this.password == "" ? false : true;
    }
  },
  methods: {
    login() {
      if (
        (this.email === "" || typeof this.email === "undefined") || (this.password === "" || typeof this.password === "undefined")
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Datos de ingreso incompletos"
        });
      } else {
        this.$store
          .dispatch("login", { email: this.email, password: this.password })
          .then(response => {
            // console.log(response)
            this.$store.commit("SET_LOGIN_SUCCESS", {
              pending: false,
              statusCode: response.status,
              data: response.data
            });
            this.$notify({
              group: "foo",
              type: "success",
              title: "ÉXITO",
              text: response.data.message
            });
            this.$store.commit("setUser", {
              email: this.email,
              role: response.data.role,
              isAuthenticated: true
            });
            this.email = "";
            this.password = "";
            this.$router.replace("/");
            this.$store
              .dispatch("addToken")
              .then(() => {
                // console.log(response)
              })
              .catch(() => {
                // console.log(error)
                // console.log(error.response)
              });
          })
          .catch(error => {
            // console.log(error)
            // console.log(error.response);
            this.$store.commit("SET_LOGIN_FAILURE", {
              pending: false,
              statusCode: error.status
            });
            this.$notify({
              group: "foo",
              type: "error",
              title: "ERROR",
              text: error.response.data.message
            });
          });
      }
    }
  }
};
</script>

<style scoped lang="scss">
#login,
.container,
.full-layout {
  width: 100vw;
  height: 100vh;
}
#login {
  background-color: #285c4d;
  img {
    width: 100%;
    height: auto;
  }
  button {
    width: 100%;
    height: 50px;
  }
}
.center-card {
  align-self: center;
}
.mg-input {
  margin: 25px 0px 15px 0px;
}
</style>
